module.exports = __webpack_public_path__ + "static/media/013.0bca56e6.jpg";